import { ExpandedTooltip, Icon } from '@livable/saas-react-components';
import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as uuid } from 'uuid';
import AllocationProgressTableRow from '../AllocationProgressTableRow';
import useStyles from '../styles';
export default function AllocationProgressTable(_ref) {
  let _ref$allocation = _ref.allocation,
    allocation = _ref$allocation === void 0 ? {} : _ref$allocation,
    noTotal = _ref.noTotal;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TableContainer, {
    className: classes.table
  }, /*#__PURE__*/React.createElement(Table, {
    "aria-label": "allocation table",
    type: "fullWidth"
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, t('allocations.utility')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('allocations.service_start')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('allocations.service_end')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('allocations.bill_value')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.cellWithHint
  }, t('allocations.cad'), /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "grey",
    title: t('allocations.cad_hint'),
    placement: "top"
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: classes.inlineTooltip
  }, /*#__PURE__*/React.createElement(Icon, {
    state: "info",
    type: "question"
  }))))), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.cellWithHint
  }, t('allocations.gwd'), /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "grey",
    title: t('allocations.gwd_hint'),
    placement: "top"
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: classes.inlineTooltip
  }, /*#__PURE__*/React.createElement(Icon, {
    state: "info",
    type: "question"
  }))))), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('allocations.ratio_billed')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('allocations.total')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('allocations.status')))), /*#__PURE__*/React.createElement(TableBody, null, allocation.utilities.map(utility => /*#__PURE__*/React.createElement(AllocationProgressTableRow, {
    key: uuid(),
    utility: utility
  }))))), !noTotal && /*#__PURE__*/React.createElement("div", {
    className: classes.summary
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, t('allocations.total_utility_charges'), "\xA0"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "$NNN.NN")));
}
AllocationProgressTable.propTypes = {
  utilities: PropTypes.array,
  allocation: PropTypes.shape({
    showOptimizationBlock: PropTypes.bool,
    title: PropTypes.string,
    enrollment: PropTypes.string,
    billValue: PropTypes.string,
    cad: PropTypes.string,
    goodwillDeduction: PropTypes.string,
    ratioBilled: PropTypes.string,
    submetered: PropTypes.string,
    total: PropTypes.string,
    status: PropTypes.shape({
      PendingCompletion: PropTypes.array
    }),
    serviceEndDateOnly: PropTypes.string,
    serviceStartDateOnly: PropTypes.string,
    isCurrent: PropTypes.bool
  })
};